import { bl_inv_bin_marking_RowClass, bl_inv_bin_marking_RowInterface } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class InvBinMarkingContainerModel extends BaseContainerModel {
  bl_inv_bin_marking: bl_inv_bin_marking_RowInterface = new bl_inv_bin_marking_RowClass();
}